import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: { query: string } = { query: '' };

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    search: (state, { payload }: PayloadAction<string>) => {
      state.query = payload;
    },
  },
});

export const reducer = searchSlice.reducer;
